import React, { FC, Suspense, lazy } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import AuthenticatedLayout from "../../widgets/authenticated-layout";
import LoaderScreen from "../../shared/ui/feedback/LoaderScreen";

const AppointmentListScreen = lazy(
  () => import("../../pages/appointment-list"),
);
const CustomerPortalAppPatientProvideInformationScreen = lazy(
  () => import("../../pages/patient-information/customer-portal"),
);
const PatientChangeInformationScreen = lazy(
  () => import("../../pages/change-patient-information"),
);
const CustomerPortalAppPatientPrivacyFormScreen = lazy(
  () => import("../../pages/privacy-form/customer-portal"),
);
const CustomerPortalAppPatientConsentFormScreen = lazy(
  () => import("../../pages/consent-form/customer-portal"),
);
const CustomerPortalAppointmentScreeningFormScreen = lazy(
  () => import("../../pages/screening-form/customer-portal"),
);
const AppointmentReportUnexpectedFindingsConfirmationScreen = lazy(
  () =>
    import(
      "../../features/report/ui/AppointmentReportUnexpectedFindingsConfirmationScreen"
    ),
);

const AuthenticatedRoot: FC = () => {
  return (
    <Suspense fallback={<LoaderScreen />}>
      <Routes>
        <Route
          path="/"
          element={
            <AuthenticatedLayout>
              <AppointmentListScreen />
            </AuthenticatedLayout>
          }
        />
        <Route
          path="/appointment/:appointmentId/provide-patient-information"
          element={
            <AuthenticatedLayout>
              <CustomerPortalAppPatientProvideInformationScreen />
            </AuthenticatedLayout>
          }
        />
        <Route
          path="/appointment/:appointmentId/change-patient-information"
          element={
            <AuthenticatedLayout>
              <PatientChangeInformationScreen />
            </AuthenticatedLayout>
          }
        />
        <Route
          path="/provide-privacy-form"
          element={
            <AuthenticatedLayout>
              <CustomerPortalAppPatientPrivacyFormScreen />
            </AuthenticatedLayout>
          }
        />
        <Route
          path="/provide-consent-form"
          element={
            <AuthenticatedLayout>
              <CustomerPortalAppPatientConsentFormScreen />
            </AuthenticatedLayout>
          }
        />
        <Route
          path="/provide-screening-form"
          element={
            <AuthenticatedLayout>
              <CustomerPortalAppointmentScreeningFormScreen />
            </AuthenticatedLayout>
          }
        />
        <Route
          path="/confirmation/:confirmationToken"
          element={<AppointmentReportUnexpectedFindingsConfirmationScreen />}
        />
        <Route path="*" element={<Navigate replace to="/" />} />
      </Routes>
    </Suspense>
  );
};

export default AuthenticatedRoot;
